export const CANCEL: string = "cancel";
export const FINISH: string = "finish";
export const MORE_COLOURS: string = "more_colours";
export const NEW_PATCHES: string = "new_patches";
export const NEXT: string = "next";
export const PLAY: string = "play";
export const PLAY_AGAIN: string = "play_again";
export const PREVIOUS: string = "previous";
export const SELECT: string = "select";
export const TRY_AGAIN: string = "try_again";
export const CLEAR: string = "clear";
export const DOLL_BUTTON: string = "doll_button";
export const DRESS_BUTTON: string = "dress_button";
export const HIERO_BUTTON_PREFIX: string = "hiero_button-";
export const HIERO_BUTTON: string = "hiero_button";
export const MASK_BUTTON: string = "mask_button";
export const PINATA_BUTTON: string = "andy_01";
export const PUPPET_BUTTON: string = "andy_02";
export const QUILT_BUTTON: string = "quilt_button";
export const ONBOARDING_00: string = "onboarding-00";
export const ONBOARDING_01: string = "onboarding-01";
export const ONBOARDING_02: string = "onboarding-02";
export const HELLO: string = "hello";
export const HEY: string = "hey";
export const HI: string = "hi";
export const HMM: string = "hmm";
export const MHM: string = "mhm";
export const INTERESTING: string = "interesting";
export const HM_OOPS: string = "hm_oops";
export const HM_UHOH: string = "hm_uhoh";
export const HM_WOOPS: string = "hm_woops";
export const NICE: string = "nice";
export const EXCELLENT: string = "excellent";
export const INCREDIBLE: string = "incredible";
export const AWESOME: string = "awesome";
export const WHOA: string = "whoa";
export const WOW: string = "wow";
export const OH: string = "oh";
export const THATS_AMAZING: string = "thats_amazing";
export const TITLE: string = "title";

export const FUN_FACT_DOLL_COMMON: string[] = [
    "ff-doll-00",
    "ff-doll-01",
    "ff-doll-02",
    "ff-doll-03",
    "ff-doll-04",
    "ff-doll-05",
    "ff-doll-06",
    "ff-doll-07",
    "ff-doll-08",
];
export const FUN_FACT_DOLL_UNIQUE: string[][] = [[]];

export const FUN_FACT_DRESS_COMMON: string[] = [];
export const FUN_FACT_DRESS_UNIQUE: string[][] = [
    [
        "ff-dress-00-00",
        "ff-dress-00-01",
        "ff-dress-00-02",
        "ff-dress-00-03",
        "ff-dress-00-04",
        "ff-dress-00-05",
        "ff-dress-00-06",
    ],
    [
        "ff-dress-01-00",
        "ff-dress-01-01",
        "ff-dress-01-02",
        "ff-dress-01-03",
        "ff-dress-01-04",
    ],
];

export const FUN_FACT_HIERO_COMMON: string[] = [
    "ff-hiero-00",
    "ff-hiero-01",
    "ff-hiero-02",
    "ff-hiero-03",
    "ff-hiero-04",
    "ff-hiero-05",
    "ff-hiero-06",
    "ff-hiero-07",
    "ff-hiero-08",
    "ff-hiero-09",
];
export const FUN_FACT_HIERO_UNIQUE: string[][] = [[]];

export const FUN_FACT_MASK_COMMON: string[] = [
    "ff-mask-01-07",
    "ff-mask-01-09",
];
export const FUN_FACT_MASK_UNIQUE: string[][] = [
    [
        "ff-mask-00-06",
        "ff-mask-00-00",
        "ff-mask-00-01",
        "ff-mask-00-02",
        "ff-mask-00-03",
        "ff-mask-00-04",
        "ff-mask-00-05",
    ],
    [
        "ff-mask-01-01",
        "ff-mask-01-00",
        "ff-mask-01-02",
        "ff-mask-01-03",
        "ff-mask-01-04",
        "ff-mask-01-05",
        "ff-mask-01-06",
        "ff-mask-01-08",
    ],
];

export const FUN_FACT_QUILT_COMMON: string[] = [
    "ff-quilt-00",
    "ff-quilt-01",
    "ff-quilt-02",
    "ff-quilt-03",
    "ff-quilt-04",
    "ff-quilt-05",
    "ff-quilt-06",
    "ff-quilt-07",
    "ff-quilt-08",
    "ff-quilt-10",
    "ff-quilt-12",
];
export const FUN_FACT_QUILT_UNIQUE: string[][] = [
    [
        "ff-quilt-09",
    ],
    [
        "ff-quilt-13",
    ],
];

export const FUN_FACT_PINATA_COMMON: string[] = [
    "andy_06",
    "andy_07",
    "andy_08",
];
export const FUN_FACT_PINATA_UNIQUE: string[][] = [[]];
